export const ROLES = {
  CLIENT: "Client User",
  SUPER_ADMIN: "Super Admin",
  MDA_ANALYST_USER: "MDA Analyst User",
};

export const PERMISSIONS = {
  VIEW_SEARCH: "search.view",
  VIEW_ADMIN: "dashboard.view",
  VIEW_WATCHLIST: "watchlist.view",
};
